// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Client View Container */
.client-view-container {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

/* Header with Search and Actions */
.client-view-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.month-picker {
  min-width: 150px;
}

.month-picker .ant-picker-input > input {
  font-weight: 500;
}

.search-container {
  width: 300px;
}

.client-search {
  border-radius: 8px;
}

.client-view-actions {
  display: flex;
  gap: 12px;
}

.export-button {
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.export-button:hover {
  background-color: #e0efff;
  color: #2563eb;
  border-color: #b0d0fc;
}

/* Client Table */
.client-table {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #eaedf3;
  margin-bottom: 20px;
}

.client-table-header {
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr;
  background-color: #f8f9fa;
  padding: 12px 16px;
  font-weight: 600;
  color: #333333;
  border-bottom: 1px solid #eaedf3;
}

.client-header-cell {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.client-header-cell.sortable {
  cursor: pointer;
  transition: color 0.2s ease;
}

.client-header-cell.sortable:hover {
  color: #3B82F6;
}

.sort-icon {
  font-size: 12px;
}

.clients-table-body {
  max-height: 500px;
  overflow-y: auto;
}

.client-row {
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr;
  padding: 12px 16px;
  border-bottom: 1px solid #eaedf3;
  transition: background-color 0.2s ease;
}

.client-row:hover {
  background-color: #f8f9fa;
}

.client-row:last-child {
  border-bottom: none;
}

.client-cell {
  font-size: 14px;
  color: #333333;
}

.client-name {
  font-weight: 500;
}

.client-id {
  color: #666666;
}

.client-count {
  font-weight: 600;
  color: #3B82F6;
}

.no-data-row {
  padding: 24px;
  text-align: center;
  color: #666666;
  font-style: italic;
}

/* Pagination */
.client-pagination {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

/* Summary */
.client-summary {
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid #eaedf3;
}

.summary-item {
  text-align: center;
}

.summary-label {
  font-size: 12px;
  color: #666666;
  margin-bottom: 4px;
}

.summary-value {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}

/* Loading State */
.client-view-loading {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.shimmer-client-search {
  height: 40px;
  width: 300px;
  background-color: #eaeaea;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.shimmer-client-table {
  height: 400px;
  width: 100%;
  background-color: #eaeaea;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.shimmer-client-pagination {
  height: 32px;
  width: 300px;
  background-color: #eaeaea;
  border-radius: 8px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .client-view-header {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .header-left {
    flex-direction: column;
  }
  
  .month-picker,
  .search-container {
    width: 100%;
  }
  
  .client-table-header,
  .client-row {
    grid-template-columns: 2fr 1fr 1fr;
    font-size: 12px;
  }
  
  .client-cell {
    font-size: 12px;
  }
  
  .client-summary {
    flex-direction: column;
    gap: 12px;
  }
  
  .summary-item {
    text-align: left;
  }
} 

.client-cell-total{
  font-size: 12px;
  color: #333333;
}

.client-cell-incentive_amount{
  font-size: 12px;
  color: #333333;
}

.client-cell-total{
  font-size: 12px;
  color: #333333;
}

`, "",{"version":3,"sources":["webpack://./src/components/Contribution/Incentive/ClientView.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,kCAAkC;IAClC,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* Client View Container */\n.client-view-container {\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n}\n\n/* Header with Search and Actions */\n.client-view-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.month-picker {\n  min-width: 150px;\n}\n\n.month-picker .ant-picker-input > input {\n  font-weight: 500;\n}\n\n.search-container {\n  width: 300px;\n}\n\n.client-search {\n  border-radius: 8px;\n}\n\n.client-view-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.export-button {\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.export-button:hover {\n  background-color: #e0efff;\n  color: #2563eb;\n  border-color: #b0d0fc;\n}\n\n/* Client Table */\n.client-table {\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #eaedf3;\n  margin-bottom: 20px;\n}\n\n.client-table-header {\n  display: grid;\n  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr;\n  background-color: #f8f9fa;\n  padding: 12px 16px;\n  font-weight: 600;\n  color: #333333;\n  border-bottom: 1px solid #eaedf3;\n}\n\n.client-header-cell {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: center;\n}\n\n.client-header-cell.sortable {\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.client-header-cell.sortable:hover {\n  color: #3B82F6;\n}\n\n.sort-icon {\n  font-size: 12px;\n}\n\n.clients-table-body {\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.client-row {\n  display: grid;\n  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr;\n  padding: 12px 16px;\n  border-bottom: 1px solid #eaedf3;\n  transition: background-color 0.2s ease;\n}\n\n.client-row:hover {\n  background-color: #f8f9fa;\n}\n\n.client-row:last-child {\n  border-bottom: none;\n}\n\n.client-cell {\n  font-size: 14px;\n  color: #333333;\n}\n\n.client-name {\n  font-weight: 500;\n}\n\n.client-id {\n  color: #666666;\n}\n\n.client-count {\n  font-weight: 600;\n  color: #3B82F6;\n}\n\n.no-data-row {\n  padding: 24px;\n  text-align: center;\n  color: #666666;\n  font-style: italic;\n}\n\n/* Pagination */\n.client-pagination {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n/* Summary */\n.client-summary {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 16px;\n  border-top: 1px solid #eaedf3;\n}\n\n.summary-item {\n  text-align: center;\n}\n\n.summary-label {\n  font-size: 12px;\n  color: #666666;\n  margin-bottom: 4px;\n}\n\n.summary-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333333;\n}\n\n/* Loading State */\n.client-view-loading {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.shimmer-client-search {\n  height: 40px;\n  width: 300px;\n  background-color: #eaeaea;\n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.shimmer-client-table {\n  height: 400px;\n  width: 100%;\n  background-color: #eaeaea;\n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.shimmer-client-pagination {\n  height: 32px;\n  width: 300px;\n  background-color: #eaeaea;\n  border-radius: 8px;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .client-view-header {\n    flex-direction: column;\n    gap: 16px;\n    align-items: stretch;\n  }\n  \n  .header-left {\n    flex-direction: column;\n  }\n  \n  .month-picker,\n  .search-container {\n    width: 100%;\n  }\n  \n  .client-table-header,\n  .client-row {\n    grid-template-columns: 2fr 1fr 1fr;\n    font-size: 12px;\n  }\n  \n  .client-cell {\n    font-size: 12px;\n  }\n  \n  .client-summary {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .summary-item {\n    text-align: left;\n  }\n} \n\n.client-cell-total{\n  font-size: 12px;\n  color: #333333;\n}\n\n.client-cell-incentive_amount{\n  font-size: 12px;\n  color: #333333;\n}\n\n.client-cell-total{\n  font-size: 12px;\n  color: #333333;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
